var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunModalElement_close, _DuoyunModalElement_ok, _DuoyunModalElement_focus, _DuoyunModalElement_onMaskClick, _DuoyunModalElement_keydown;
var DuoyunModalElement_1;
import { connectStore, adoptedStyle, customElement, attribute, emitter, property, boolattribute, refobject, part, } from '@mantou/gem/lib/decorators';
import { GemElement, html, TemplateResult } from '@mantou/gem/lib/element';
import { createCSSSheet, css, styled } from '@mantou/gem/lib/utils';
import { mediaQuery } from '@mantou/gem/helper/mediaquery';
import { theme } from '../lib/theme';
import { locale } from '../lib/locale';
import { hotkeys } from '../lib/hotkeys';
import { setBodyInert } from '../lib/utils';
import './button';
import './divider';
const style = createCSSSheet(css `
  :host {
    view-transition-name: dy-modal;
    position: fixed;
    z-index: ${theme.popupZIndex};
    top: env(titlebar-area-height, var(--titlebar-area-height, 0px));
    left: 0;
    width: 100%;
    height: calc(100% - env(titlebar-area-height, var(--titlebar-area-height, 0px)));
    display: none;
  }
  .absolute {
    position: absolute;
  }
  .mask {
    inset: 0;
    animation: showMask 0.1s ${theme.timingFunction} forwards;
  }
  @keyframes showMask {
    0% {
      background-color: transparent;
    }
    100% {
      background-color: rgba(0, 0, 0, calc(${theme.maskAlpha} + 0.2));
    }
  }
  :host([open]) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog {
    outline: none;
    animation: showDialog 0.1s ${theme.timingFunction} forwards;
  }
  .main {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 20em;
    min-height: 10em;
    max-height: 80%;
    max-width: 90%;
    background-color: ${theme.backgroundColor};
    color: ${theme.textColor};
    padding: 1.5em 1.2em;
    box-shadow: 0 5px 10px rgba(0, 0, 0, calc(${theme.maskAlpha} - 0.15));
    border-radius: calc(${theme.normalRound} * 3);
  }
  @keyframes showDialog {
    0% {
      transform: translate(0, 50%);
      opacity: 0;
    }
    100% {
      transform: translate(0);
      opacity: 1;
    }
  }
  .header {
    font-size: 1.125em;
    color: ${theme.highlightColor};
    font-weight: bold;
    user-select: none;
    padding-bottom: 0.5em;
  }
  .header-divider {
    margin-block-end: 1em;
  }
  .body {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    scrollbar-width: none;
    overscroll-behavior: contain;
    min-height: 2em;
  }
  .body::-webkit-scrollbar {
    width: 0;
  }
  .footer {
    margin-top: 1.5em;
  }
  .footer,
  slot[name='footer']::slotted(*) {
    display: flex;
    justify-content: flex-end;
    gap: 0.7em;
  }
  @media ${mediaQuery.PHONE} {
    .main {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      height: 100%;
    }
  }
`);
const style2 = createCSSSheet({
    p: styled.class `
    margin: 0;
  `,
    c: styled.class `
    &::first-letter {
      text-transform: capitalize;
    }
  `,
});
/**
 * @customElement dy-modal
 * @fires ok
 * @fires close
 * @fires maskclick
 */
let DuoyunModalElement = DuoyunModalElement_1 = class DuoyunModalElement extends GemElement {
    constructor({ header, open, customize, maskCloseable, cancelText, okText, body, disableDefaultCancelBtn, disableDefaultOKBtn, dangerDefaultOkBtn, } = {}) {
        super();
        _DuoyunModalElement_close.set(this, () => {
            this.close(null);
        });
        _DuoyunModalElement_ok.set(this, () => {
            this.ok(null);
        });
        _DuoyunModalElement_focus.set(this, () => {
            var _a;
            (_a = this.shadowRoot.querySelector('.dialog')) === null || _a === void 0 ? void 0 : _a.focus();
        });
        _DuoyunModalElement_onMaskClick.set(this, () => {
            if (this.maskCloseable)
                __classPrivateFieldGet(this, _DuoyunModalElement_close, "f").call(this);
            this.maskclick(null);
            __classPrivateFieldGet(this, _DuoyunModalElement_focus, "f").call(this);
        });
        _DuoyunModalElement_keydown.set(this, (evt) => {
            evt.stopPropagation();
            hotkeys({ esc: __classPrivateFieldGet(this, _DuoyunModalElement_close, "f") })(evt);
        });
        this.mounted = () => {
            this.effect(() => {
                var _a;
                if (this.open && !((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.activeElement)) {
                    __classPrivateFieldGet(this, _DuoyunModalElement_focus, "f").call(this);
                }
            }, () => [this.open]);
            this.addEventListener('keydown', __classPrivateFieldGet(this, _DuoyunModalElement_keydown, "f"));
            return () => this.removeEventListener('keydown', __classPrivateFieldGet(this, _DuoyunModalElement_keydown, "f"));
        };
        this.render = () => {
            if (!this.open)
                return html ``;
            return html `
      <div class="mask absolute" @click=${__classPrivateFieldGet(this, _DuoyunModalElement_onMaskClick, "f")}></div>
      ${this.customize
                ? html `
            <div
              part=${DuoyunModalElement_1.dialog}
              role="dialog"
              tabindex="0"
              aria-modal="true"
              class="dialog absolute"
              ref=${this.bodyRef.ref}
            >
              ${this.body || html `<slot name="body"></slot>`}
            </div>
          `
                : html `
            <div
              part=${DuoyunModalElement_1.dialog}
              role="dialog"
              tabindex="0"
              aria-modal="true"
              class="dialog main absolute"
            >
              ${this.header
                    ? html `
                    <div part=${DuoyunModalElement_1.heading} role="heading" aria-level="1" class="header">
                      ${this.header}
                    </div>
                    <dy-divider part=${DuoyunModalElement_1.divider} class="header-divider" size="medium"></dy-divider>
                  `
                    : ''}
              <div class="body" part=${DuoyunModalElement_1.body}>
                <slot name="body" ref=${this.bodyRef.ref}>${this.body}</slot>
              </div>
              <div class="footer" part=${DuoyunModalElement_1.footer}>
                <slot name="footer">
                  <dy-button ?hidden=${this.disableDefaultCancelBtn} @click=${__classPrivateFieldGet(this, _DuoyunModalElement_close, "f")} .color=${'cancel'}>
                    ${this.cancelText || locale.cancel}
                  </dy-button>
                  <dy-button
                    ?hidden=${this.disableDefaultOKBtn}
                    .color=${this.dangerDefaultOkBtn ? 'danger' : 'normal'}
                    @click=${__classPrivateFieldGet(this, _DuoyunModalElement_ok, "f")}
                    >${this.okText || locale.ok}</dy-button
                  >
                </slot>
              </div>
            </div>
          `}
    `;
        };
        if (header)
            this.header = header;
        if (customize)
            this.customize = customize;
        if (maskCloseable)
            this.maskCloseable = maskCloseable;
        if (open)
            this.open = open;
        if (cancelText)
            this.cancelText = cancelText;
        if (okText)
            this.okText = okText;
        if (disableDefaultCancelBtn)
            this.disableDefaultCancelBtn = disableDefaultCancelBtn;
        if (disableDefaultOKBtn)
            this.disableDefaultOKBtn = disableDefaultOKBtn;
        if (dangerDefaultOkBtn)
            this.dangerDefaultOkBtn = dangerDefaultOkBtn;
        if (body)
            this.body = body;
    }
    // Cannot be used for dynamic forms
    static async open(options) {
        const modal = new this({ ...options, open: true });
        const restoreInert = setBodyInert(modal);
        document.body.append(modal);
        // bubble close event close modal
        return new Promise((res, rej) => {
            modal.addEventListener('close', () => {
                rej();
            });
            modal.addEventListener('ok', () => {
                const { element } = modal.bodyRef;
                if (element) {
                    const ele = element.children[0];
                    res(ele instanceof HTMLSlotElement ? ele.assignedElements()[0] : ele);
                }
            });
        }).finally(() => {
            restoreInert();
            modal.remove();
        });
    }
    static confirm(body, options) {
        const content = typeof body === 'string' || body instanceof TemplateResult
            ? html `<div class=${style2.c}>${body}</div>`
            : html `<pre class=${style2.p}>${JSON.stringify(body, null, 2)}</pre>`;
        return Modal.open({ ...options, body: content });
    }
};
_DuoyunModalElement_close = new WeakMap(), _DuoyunModalElement_ok = new WeakMap(), _DuoyunModalElement_focus = new WeakMap(), _DuoyunModalElement_onMaskClick = new WeakMap(), _DuoyunModalElement_keydown = new WeakMap();
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "open", void 0);
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "customize", void 0);
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "maskCloseable", void 0);
__decorate([
    attribute
], DuoyunModalElement.prototype, "okText", void 0);
__decorate([
    attribute
], DuoyunModalElement.prototype, "cancelText", void 0);
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "disableDefaultCancelBtn", void 0);
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "disableDefaultOKBtn", void 0);
__decorate([
    boolattribute
], DuoyunModalElement.prototype, "dangerDefaultOkBtn", void 0);
__decorate([
    emitter
], DuoyunModalElement.prototype, "close", void 0);
__decorate([
    emitter
], DuoyunModalElement.prototype, "ok", void 0);
__decorate([
    emitter
], DuoyunModalElement.prototype, "maskclick", void 0);
__decorate([
    property
], DuoyunModalElement.prototype, "header", void 0);
__decorate([
    property
], DuoyunModalElement.prototype, "body", void 0);
__decorate([
    refobject
], DuoyunModalElement.prototype, "bodyRef", void 0);
__decorate([
    part
], DuoyunModalElement, "dialog", void 0);
__decorate([
    part
], DuoyunModalElement, "heading", void 0);
__decorate([
    part
], DuoyunModalElement, "divider", void 0);
__decorate([
    part
], DuoyunModalElement, "body", void 0);
__decorate([
    part
], DuoyunModalElement, "footer", void 0);
DuoyunModalElement = DuoyunModalElement_1 = __decorate([
    customElement('dy-modal'),
    adoptedStyle(style),
    adoptedStyle(style2),
    connectStore(locale)
], DuoyunModalElement);
export { DuoyunModalElement };
export const Modal = DuoyunModalElement;
//# sourceMappingURL=modal.js.map